import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null,
    timerData: {
      active: false,
      totalTime: 600,
      secondsLeft: 600,
      expired: false,
    },
  }),
  getters: {
    getToken: (state) => state.token,
    isTimerActive: (state) => state.timerData.active,
    isTimerExpired: (state) => state.timerData.expired,
    timerValue: (state) => (state.timerData.secondsLeft * 100) / state.timerData.totalTime,
    timeLeft: (state) => {
      if (state.timerData.secondsLeft <= 0) {
        return "00:00";
      }
      return `${String(Math.floor(state.timerData.secondsLeft / 60)).padStart(2, '0')}:${String(state.timerData.secondsLeft % 60).padStart(2, '0')}`;
    },
  },
  actions: {
    setToken(token) {
      this.token = token
    },
    startTimer() {
      this.timerData.active = true;
      setInterval(() => {
        this.timerData.secondsLeft -= 1;
        if (this.timerData.secondsLeft <= 0) {
          this.timerData.active = false;
          this.timerData.expired = true;
        }
      }, 1000);
    },
  }
})